import { GButton, GTooltip } from 'components/basic-blocks'
import { GDateTime } from 'components/basic-blocks/g-datetime'
import { RiGoogleLine, RiRobotLine, RiUser3Line } from 'react-icons/ri'
import { NavLink } from 'react-router-dom'
import { NotificationItemProps } from './types'
import { useAssetStore } from '../../../store'
import { TbBriefcase2 } from 'react-icons/tb'
import { GoGlobe } from 'react-icons/go'

export const NotificationItem = (props: NotificationItemProps) => {
	const { demoMode } = useAssetStore()
	const { data, unreadIcon, link, notificationId, solo, className } = props

	const icon = {
		USER: RiUser3Line,
		ACCOUNT: TbBriefcase2,
		CAMPAIGN: TbBriefcase2,
		WEBSITE: GoGlobe,
		PPC_ACCOUNT: {
			GADS: RiGoogleLine
		},
		SYSTEM: RiRobotLine
	}

	const chooseIcon = () => {
		if (!(data.context_type === 'PPC_ACCOUNT')) return icon[data.context_type]
		if (data.context_type === 'PPC_ACCOUNT') {
			if (data.platform === 'GADS') return icon['PPC_ACCOUNT']['GADS']
			return icon['PPC_ACCOUNT']['GADS']
		}
	}

	const Icon = chooseIcon()

	return (
		<div
			className={`flex justify-around items-center hover:bg-popover-hover hover:cursor-pointer w-full ${
				solo && 'h-20'
			}`}
		>
			<NavLink to={demoMode ? '#' : link}>
				<div
					className={`flex items-center ${className} justify-between gap-4 py-2 mr-6`}
				>
					<div className="flex items-center justify-start gap-3 w-64">
						<div>
							{Icon && (
								<Icon
									className="w-4 h-4"
									style={{ color: 'var(--t-gray-checkout)' }}
								/>
							)}
						</div>
						<div className="flex flex-col max-w-[225px]">
							<div className="text-sm font-medium text-t-coupon break-words">
								{data.message}
							</div>
							{data.context_name && (
								<div className="text-sm text-t-desc-gray truncate max-w-[200px]">
									{data.context_name}
								</div>
							)}
						</div>
					</div>
					<div className="flex items-center justify-end gap-3">
						<div className="text-t-coupon text-sm">
							<GDateTime date={data.created_at} />
						</div>
					</div>
				</div>
			</NavLink>
			<div>
				{data.id === notificationId ? (
					<GTooltip
						position="top"
						arrowClassName="w-0 h-0 absolute bottom-[0.5px] border-l-8 border-l-transparent  border-r-8 border-r-transparent border-t-8 border-t-tooltip-caret"
						contentClassName="border-none font-grotesk mb-2 bg-t-smoke w-[300px] font-medium text-sm text-t-desc-gray"
						content={`${
							demoMode
								? 'This action is disabled when demo data is displayed'
								: null
						}`}
					>
						<GButton
							className="z-10"
							type="icon"
							variant="colored"
							disabled={demoMode}
							shape="circle"
							size="xxs"
							loading={data.id === notificationId}
						/>
					</GTooltip>
				) : (
					!data.read && unreadIcon
				)}
			</div>
		</div>
	)
}
